import React, { useEffect, useState } from "react";
import { Drawer, Form, Col, Row } from "antd";
import axios from "axios";
import localhost from "../../constants/localhost";

export default ({ id }) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [detail, setDetail] = useState({});

  useEffect(() => {
    if (!open) {
      return;
    }
    axios
      .get(`${localhost}/manage/distributionManage/getDetail?id=${id}`)
      .then(() => {
        setDetail();
      });
  }, [open]);

  return (
    <>
      <a onClick={() => setOpen(true)}>详情</a>
      <Drawer
        title="详情"
        width={500}
        destroyOnHidden
        open={open}
        onClose={() => setOpen(false)}
      >
        <Row>
          <Col span={4}>作品名称</Col>
          <Col span={20}>{detail.name}</Col>
        </Row>
        <Row>
          <Col span={4}>浏览量(PV)</Col>
          <Col span={20}>{detail.pv}</Col>
        </Row>
        <Row>
          <Col span={4}>浏览量(UV)</Col>
          <Col span={20}>{detail.uv}</Col>
        </Row>
        <Row>
          <Col span={4}>状态</Col>
          <Col span={20}>{detail.status}</Col>
        </Row>
        <Row>
          <Col span={4}>排名</Col>
          <Col span={20}>{detail.ranking}</Col>
        </Row>
        <Row>
          <Col span={4}>评分</Col>
          <Col span={20}>{detail.score}</Col>
        </Row>
        <Row>
          <Col span={4}>下载量</Col>
          <Col span={20}>{detail.downloadCount}</Col>
        </Row>
        <Row>
          <Col span={4}>转发量</Col>
          <Col span={20}>{detail.repostCount}</Col>
        </Row>
        <Row>
          <Col span={4}>引用次数</Col>
          <Col span={20}>{detail.referenceCount}</Col>
        </Row>
        <Row>
          <Col span={4}>作者</Col>
          <Col span={20}>{detail.author}</Col>
        </Row>
        <Row>
          <Col span={4}>发布时间</Col>
          <Col span={20}>{detail.releaseDate}</Col>
        </Row>
        <Row>
          <Col span={4}>更新时间‌</Col>
          <Col span={20}>{detail.modifyDate}</Col>
        </Row>
        <Row>
          <Col span={4}>结束时间</Col>
          <Col span={20}>{detail.endDate}</Col>
        </Row>
      </Drawer>
    </>
  );
};
